import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getApprovedChanges = api(function getApprovedChanges(referenceId, type) {
    return query(
        gql`
            query GetApprovedChanges($referenceId: String, $type: String) {
                getApprovedChanges(referenceId: $referenceId, type: $type) {
                    id
                    shortDescription
                    longDescription
                    referenceId
                    type
                    date
                    userId
                    userName
                    payload
                }
            }
        `,
        { referenceId, type },
        { returns: "getApprovedChanges" }
    )
})
